export * from './IconSnowflake';
export { default as IconSnowflake } from './IconSnowflake';
